export default class TaxiGetRouteInfoDto {
  position: string = '{"x":0, "y":0, "z":0}';
}
